import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';

import { storage } from '../config/appwrite';




@Injectable({

providedIn: 'root'

})

export class BucketsService {



/**

*

* @returns

*/

public getBucket(bucketId: string, fileId: string){

// const result = storage.getFileDownload(bucketId, fileId);

const result = storage.getFileView(bucketId, fileId);

// console.log("file::",result['href']); // Resource URL




// const promise = storage.getFile(bucketId, fileId);

// promise.then(function (response) {

// console.log(response); // Success

// }, function (error) {

// console.log(error); // Failure

// });

return result['href']

}



}
